<template>
  <ion-modal ref="modal" trigger="open-modal" class="ion-padding">
    <ion-content>
      <ion-toolbar>
        <ion-title>Détail journée</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" @click="dismiss()">
            <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-list>
        <div
          v-for="(entry, key) in Object.values(details)"
          :key="'worksite' + key"
        >
          <h5 class="ion-padding-start">{{ entry.text }}</h5>

          <ion-item
            v-for="(detail, key) in entry.values"
            :key="'detail' + key"
            class="ion-padding-end"
            lines="none"
          >
            <ion-label class="ion-no-margin">{{ detail.text }}</ion-label>
            <div slot="end">{{ floatToString(detail.value) }}</div>
          </ion-item>

          <ion-item
            v-if="entry.total && entry.values.length > 1"
            :key="'detail-total' + key"
            class="ion-padding-end total"
            lines="none"
          >
            <ion-label class="ion-no-margin">Total</ion-label>
            <strong slot="end">{{ floatToString(entry.total) }}</strong>
          </ion-item>
        </div>
      </ion-list>
    </ion-content>
  </ion-modal>
</template>

<script>
import {
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';
import { floatToString } from '@/services/utils/dateUtils';

export default {
  name: 'DayDetailsModal',

  components: {
    IonButton,
    IonButtons,
    IonContent,
    IonList,
    IonModal,
    IonTitle,
    IonToolbar,
    IonIcon,
    IonItem,
    IonLabel,
  },

  props: {
    details: Object,
  },

  setup() {
    return {
      closeOutline,
    };
  },

  methods: {
    dismiss() {
      if (!this.$refs.modal) return;

      this.$refs.modal.$el.dismiss();
    },

    floatToString,
  },
};
</script>

<style scoped lang="scss">
ion-modal {
  // TODO: This is a hack and should be corrected with something like this:
  // https://ionicframework.com/docs/v7/api/modal#custom-sheet-height
  --height: 50%;
}

h5 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}

ion-item {
  --min-height: 26px;
  --padding-start: 24px;

  &.total {
    margin-top: 4px;
  }
}
</style>
